'use client';

import { c as _c } from "react/compiler-runtime";
import { type DepartureSubDecisionError, type DepartureSubPageContextValue } from '../departure-sub-page/departure-sub-page-provider.logic.ts';
import { useDepartureSubPage } from '../departure-sub-page/departure-sub-page-provider.tsx';
const getChildName = (child?: {
  displayName?: string | null;
  name?: {
    first?: string | null;
    preferred?: string | null;
  };
}): string => (child?.name?.preferred ?? child?.name?.first ?? child?.displayName ?? '').trim();
interface DepartureSubOverviewState {
  acceptDisplayedChild: () => Promise<void>;
  autoAcceptDate?: string | null;
  decisionError?: DepartureSubDecisionError;
  descriptionContext?: 'withDate' | 'withoutDate';
  displayedChildGlobalId?: string;
  displayedChildName: string;
  getAlternateChildPath: (childGlobalId: string) => string;
  hasGlobalId: boolean;
  hasOverviewContent: boolean;
  handleAcceptDisplayedChild: () => Promise<void>;
  isAlternateSelection: boolean;
  isDecisionPending: boolean;
  offeredChildName: string;
  offeredChildPath: string;
  selectAlternateChild: (childGlobalId: string) => void;
  showError: boolean;
  spotlightData?: {
    availability: NonNullable<DepartureSubPageContextValue['departure']['availability']>;
    childDetails: NonNullable<DepartureSubPageContextValue['departure']['displayedChild']>;
    departingChildDetails: NonNullable<DepartureSubPageContextValue['departure']['departingChild']>;
  };
}
export const useDepartureSubOverview = () => {
  const $ = _c(28);
  const {
    departure,
    decision,
    hasError,
    navigation
  } = useDepartureSubPage();
  let t0;
  if ($[0] !== departure.displayedChild) {
    t0 = getChildName(departure.displayedChild);
    $[0] = departure.displayedChild;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const displayedChildName = t0;
  let t1;
  if ($[2] !== departure.offeredChild) {
    t1 = getChildName(departure.offeredChild);
    $[2] = departure.offeredChild;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const offeredChildName = t1;
  let t2;
  if ($[4] !== departure.availability || $[5] !== departure.departingChild || $[6] !== departure.displayedChild) {
    t2 = departure.availability && departure.displayedChild && departure.departingChild ? {
      availability: departure.availability,
      childDetails: departure.displayedChild,
      departingChildDetails: departure.departingChild
    } : undefined;
    $[4] = departure.availability;
    $[5] = departure.departingChild;
    $[6] = departure.displayedChild;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const spotlightData = t2;
  const hasOverviewContent = !hasError && !!spotlightData && !!departure.displayedChildGlobalId && !!displayedChildName && !!offeredChildName;
  let t3;
  if ($[8] !== decision) {
    t3 = async () => {
      try {
        await decision.accept();
      } catch {}
    };
    $[8] = decision;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const handleAcceptDisplayedChild = t3;
  let descriptionContext;
  if (!departure.isAlternateSelection) {
    descriptionContext = departure.autoAcceptDate ? "withDate" : "withoutDate";
  }
  const t4 = !!departure.departedChildGlobalId;
  const t5 = !hasOverviewContent;
  let t6;
  if ($[10] !== decision.accept || $[11] !== decision.error || $[12] !== decision.isPending || $[13] !== departure.autoAcceptDate || $[14] !== departure.displayedChildGlobalId || $[15] !== departure.isAlternateSelection || $[16] !== descriptionContext || $[17] !== displayedChildName || $[18] !== handleAcceptDisplayedChild || $[19] !== hasOverviewContent || $[20] !== navigation.getAlternateChildPath || $[21] !== navigation.offeredChildPath || $[22] !== navigation.selectAlternateChild || $[23] !== offeredChildName || $[24] !== spotlightData || $[25] !== t4 || $[26] !== t5) {
    t6 = {
      acceptDisplayedChild: decision.accept,
      autoAcceptDate: departure.autoAcceptDate,
      decisionError: decision.error,
      descriptionContext,
      displayedChildGlobalId: departure.displayedChildGlobalId,
      displayedChildName,
      getAlternateChildPath: navigation.getAlternateChildPath,
      hasGlobalId: t4,
      hasOverviewContent,
      handleAcceptDisplayedChild,
      isAlternateSelection: departure.isAlternateSelection,
      isDecisionPending: decision.isPending,
      offeredChildName,
      offeredChildPath: navigation.offeredChildPath,
      selectAlternateChild: navigation.selectAlternateChild,
      showError: t5,
      spotlightData
    };
    $[10] = decision.accept;
    $[11] = decision.error;
    $[12] = decision.isPending;
    $[13] = departure.autoAcceptDate;
    $[14] = departure.displayedChildGlobalId;
    $[15] = departure.isAlternateSelection;
    $[16] = descriptionContext;
    $[17] = displayedChildName;
    $[18] = handleAcceptDisplayedChild;
    $[19] = hasOverviewContent;
    $[20] = navigation.getAlternateChildPath;
    $[21] = navigation.offeredChildPath;
    $[22] = navigation.selectAlternateChild;
    $[23] = offeredChildName;
    $[24] = spotlightData;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
  } else {
    t6 = $[27];
  }
  return t6;
};